import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { GetOutletDetail, DeleteHardwareDevice, GetZatcaConfigurationsList } from '../../services/company_panel/outletService';
import toHtml from 'html-react-parser'
import { formateDate, getBrandId, SpecialCharacter, TrimText, capitalizeFirstLetter } from '../../helpers/commonFunctions';
import Breadcrums from '../../components/company_panel/common/breadcrumbs'
import Loader from '../../components/company_panel/common/loader'
import Swal from 'sweetalert2'
import { ListGroups } from '../../services/company_panel/routingStationService';
import { Modal, Button } from 'react-bootstrap';
import { generateZatcaPdf } from '../../helpers/zatcaPdf';


const OutletView = () => {
    const navigate = useNavigate()
    const params = useParams()
    const [showDefault, setShowDefault] = useState({})
    const breadcrumbs = [{ title: "Outlet", url: `/company/business/outlet/list/${params?.pgno || 1}` }, { title: "Outlet Detail", url: "" }]
    const [statsUpdate, setStatusUpdate] = useState("false")
    const [routingGroupList, setRoutingGroupList] = useState([])
    const [zatcaConfigList, setZatcaConfigList] = useState([])
    const [viewZatcaModal, setViewZatcaModal] = useState(false)
    const [viewZatcaRecord, setViewZatcaRecord] = useState(null)

    useEffect(() => {
        GetOutletDetail(params.id).then(data => {
            const dataOutlet = data && data.data && data.data.response ? data.data.response : []
            setShowDefault(dataOutlet)
            if (Boolean(Number(dataOutlet?.zatca_enabled))) {
                GetZatcaConfigurationsList({ outlet_id: params.id }).then(data => {
                    setZatcaConfigList(data?.data?.response || [])
                }).catch(error => {
                    console.log("error=====>", error)
                })
            } else {
                setZatcaConfigList([])
            }
        }).catch(error => {
            console.log("error=====>", error)
        })

        ListGroups({ brand_id: getBrandId() }).then(data => {
            setRoutingGroupList(data?.data?.response.rows);
        }).catch(error => {
            console.log("error ====> ", error);
        })
    }, [statsUpdate]);


    function deleteFunction(row) {
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#403fad',
            cancelButtonColor: '#f1388b',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                const formdata = new FormData()
                formdata.append("id", row)
                DeleteHardwareDevice(formdata).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: 'Device deleted successfully',
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                        setStatusUpdate(!statsUpdate)
                    }
                }).catch(error => {
                    console.log("deleteError", error)
                })
            }
        })
    }

    const capitalizeFirstLetter = (string) => {
        return string?.charAt(0)?.toUpperCase() + string?.slice(1);
    };


    return (
        <>

            <div className="page-header d-flex align-items-center">
                <div className="page-header-left">
                    <Breadcrums data={breadcrumbs} />
                    <h4>Outlets</h4>
                </div>
                <div className="page-header-right ms-auto">

                </div>
            </div>
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div>
                                <h3 className="main-content-label mb-3">Outlet Info</h3>
                            </div>
                            {showDefault && Object.keys(showDefault).length > 0 ? <div className='row'>
                                <div className="col-lg-12 form-group">
                                    <table id="simple-table" className="table table">
                                        <tbody>
                                            <tr>
                                                <div className='d-flex justify-content-between'>
                                                    <td>Outlet Name</td>
                                                    <td>{showDefault && showDefault.outlet_name ? capitalizeFirstLetter(showDefault.outlet_name) : "N/A"}</td>
                                                </div>
                                            </tr>
                                            <tr>
                                                <div className='d-flex justify-content-between'>
                                                    <td>Outlet Name (Arabic)</td>
                                                    <td>{showDefault && showDefault.outlet_name_ar ? capitalizeFirstLetter(showDefault.outlet_name_ar) : "N/A"}</td>
                                                </div>
                                            </tr>
                                            <tr>
                                                <div className='d-flex justify-content-between'>
                                                    <td>Shortcode</td>
                                                    <td>{showDefault && showDefault.short_code ? capitalizeFirstLetter(showDefault.short_code) : "N/A"}</td>
                                                </div>
                                            </tr>
                                            {/* <tr>
                                                <div className='d-flex justify-content-between'>
                                                    <td>VAT information</td>
                                                    <td>{showDefault && showDefault.vat_information ? capitalizeFirstLetter(showDefault.vat_information) : "N/A"}</td>
                                                </div>
                                            </tr> */}
                                            <tr>
                                                <div className='d-flex justify-content-between'>
                                                    <td>Brand Name</td>
                                                    <td>{showDefault && showDefault.brand ? capitalizeFirstLetter(showDefault.brand.name) : "N/A"}</td>
                                                </div>
                                            </tr>
                                            <tr>
                                                <div className='d-flex justify-content-between'>
                                                    <td>Created Date</td>
                                                    <td>{showDefault && showDefault.created_at ? formateDate(showDefault.created_at) : "N/A"}</td>
                                                </div>
                                            </tr>
                                            <tr>
                                                <div className='d-flex justify-content-between'>
                                                    <td>Email</td>
                                                    <td>{showDefault && showDefault.email ? showDefault.email : "N/A"}</td>
                                                </div>
                                            </tr>
                                            <tr>
                                                <div className='d-flex justify-content-between'>
                                                    <td>Address</td>
                                                    <td>{showDefault && showDefault.location ? capitalizeFirstLetter(showDefault.location) : "N/A"}</td>
                                                </div>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className='row row-sm'>
                                        <div className='col-lg-6 col-md-6 animation_fade'>
                                            <div className="card custom-card">
                                                <div className="card-body">
                                                    <h3 className="main-content-label mb-3">Hardware Details</h3>
                                                    {showDefault.outlet_hardware_details.length ? showDefault.outlet_hardware_details.map((row, i) => (
                                                        <table key={i} id="simple-table" className="table ">
                                                            <div className='d-flex justify-content-between align-items-center py-3' >
                                                                <h3>{row && row?.hardware_used ? capitalizeFirstLetter(SpecialCharacter(row?.hardware_used)) : "N/A"}</h3>
                                                                <a className="" onClick={() => { deleteFunction(row.id) }} style={{ cursor: 'pointer' }}>Delete Device</a>
                                                            </div>
                                                            {row?.hardware_used == "printer" || row?.hardware_used == "pos" ?
                                                                <>
                                                                    <tbody style={{ border: 'none' }}>
                                                                        <tr>
                                                                            <div className='d-flex justify-content-between'>
                                                                                <td>Registration ID :</td>
                                                                                <td>{row && row.registration_id ? capitalizeFirstLetter(row.registration_id) : "-"}</td>
                                                                            </div>
                                                                        </tr>
                                                                        <tr>
                                                                            <div className='d-flex justify-content-between'>
                                                                                <td>Name :</td>
                                                                                <td>{row && row.name ? capitalizeFirstLetter(row.name) : "-"}</td>
                                                                            </div>
                                                                        </tr>
                                                                        <tr>
                                                                            <div className='d-flex justify-content-between'>
                                                                                <td>SDK ID :</td>
                                                                                <td>{row && row.sdk_id ? capitalizeFirstLetter(row.sdk_id) : "-"}</td>
                                                                            </div>
                                                                        </tr>
                                                                        {row?.outlet_routing_group_relations.length > 0 &&
                                                                            <tr>
                                                                                <div className='d-flex justify-content-between'>
                                                                                    <td>Routing Station:</td>
                                                                                    <td className="d-flex justify-content-end">
                                                                                        <div className='w-75 d-flex justify-content-end flex-wrap gap-1'>
                                                                                            {row?.outlet_routing_group_relations?.map((station, idx) => {
                                                                                                const matchedGroup = routingGroupList.find(group => group.id == station?.routing_);
                                                                                                const isLast = idx === row.outlet_routing_group_relations.length - 1;
                                                                                                return <div key={idx}>{" "}{matchedGroup?.name}{!isLast && matchedGroup?.name ? "," : ""}</div>;
                                                                                            })}
                                                                                        </div>
                                                                                    </td>
                                                                                </div>
                                                                            </tr>
                                                                        }
                                                                        {/* {
                                                                            row?.printer_type !== null && (
                                                                                <tr>
                                                                                    <td>
                                                                                        <div className='d-flex justify-content-between'>
                                                                                            <span>Printer Type :</span>
                                                                                            <span>{row.printer_type ? capitalizeFirstLetter(row.printer_type) : "-"}</span>
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        } */}

                                                                    </tbody>
                                                                </>
                                                                : null}
                                                        </table>
                                                    )) : ''}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-6 animation_fade'>
                                            <div className="card custom-card">
                                                <div className="card-body">
                                                    <h3 className="main-content-label mb-3">Store Settings</h3>
                                                    <table id="simple-table" className="table  ">
                                                        <tbody>
                                                            <tr>
                                                                <div>
                                                                    <td>Invoice Header Text Info</td>
                                                                    <div>{showDefault && showDefault.invoice_header_text_info ? showDefault.invoice_header_text_info : ""}</div>
                                                                </div>
                                                            </tr>
                                                            <tr>
                                                                <div>
                                                                    <td>Invoice Footer Text Info</td>
                                                                    <div>{showDefault && showDefault.invoice_footer_text_info ? showDefault.invoice_footer_text_info : ""}</div>
                                                                </div>
                                                            </tr>
                                                            <tr>
                                                                <div>
                                                                    <td>End of the day configuration</td>
                                                                    <div>{showDefault && showDefault.end_of_the_day_configuration ? capitalizeFirstLetter(showDefault.end_of_the_day_configuration) : ""}: {showDefault && showDefault.end_of_the_day_time ? showDefault.end_of_the_day_time : ""}</div>
                                                                </div>
                                                            </tr>
                                                            <td colSpan="3">
                                                                <td>Store opening and closing time</td>
                                                                <div className='row'>
                                                                    {showDefault.monday_opening_time === 'null' || showDefault.monday_closing_time === 'null'
                                                                        ? '' :
                                                                        <div className='col-6'>Monday : {showDefault.monday_opening_time} - {showDefault.monday_closing_time}</div>}


                                                                    {showDefault.tuesday_opening_time === 'null' || showDefault.tuesday_closing_time === 'null'
                                                                        ? '' :
                                                                        <div className='col-6'>Tuesday : {showDefault.tuesday_opening_time} - {showDefault.tuesday_closing_time} </div>}


                                                                    {showDefault.wednesday_opening_time === 'null' || showDefault.wednesday_closing_time === 'null'
                                                                        ? '' :
                                                                        <div className='col-6'> Wednesday : {showDefault.wednesday_opening_time} - {showDefault.wednesday_closing_time}</div>}


                                                                    {showDefault.thursday_opening_time === 'null' || showDefault.thursday_closing_time === 'null'
                                                                        ? '' :
                                                                        <div className='col-6'>Thursday : {showDefault.thursday_opening_time} - {showDefault.thursday_closing_time}</div>}


                                                                    {showDefault.friday_opening_time === 'null' || showDefault.friday_closing_time === 'null'
                                                                        ? '' :
                                                                        <div className='col-6'>Friday : {showDefault.friday_opening_time} - {showDefault.friday_closing_time}</div>}


                                                                    {showDefault.saturday_opening_time === 'null' || showDefault.saturday_closing_time === 'null'
                                                                        ? '' :
                                                                        <div className='col-6'>Saturday : {showDefault.saturday_opening_time} - {showDefault.saturday_closing_time}</div>}


                                                                    {showDefault.sunday_opening_time === 'null' || showDefault.sunday_closing_time === 'null'
                                                                        ? '' :
                                                                        <div className='col-6'>Sunday : {showDefault.sunday_opening_time} - {showDefault.sunday_closing_time}</div>}

                                                                </div>
                                                            </td>

                                                            <tr>
                                                                <div className='d-flex justify-content-between'>
                                                                    <td>How many copy of the check will be print ?</td>
                                                                    <td>{showDefault && showDefault.copy_print_count ? showDefault.copy_print_count : " "}</td>
                                                                </div>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        {Boolean(Number(showDefault?.zatca_enabled)) &&
                                        <div className='col-lg-6 col-md-6 animation_fade'>
                                            <div className="card custom-card">
                                                <div className="card-body">
                                                    <h3 className="main-content-label mb-3">Zatca Configurations</h3>
                                                    <div className="table-responsive">
                                                        {zatcaConfigList && zatcaConfigList.length ? (
                                                            <table id="simple-table" className="table table-bordered align-middle">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Configuration Name</th>
                                                                        <th>Type</th>
                                                                        <th>Environment</th>
                                                                        <th className="text-center">Actions</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {zatcaConfigList.map(cfg => (
                                                                        <tr key={cfg.id}>
                                                                            <td>{capitalizeFirstLetter(cfg.configuration_name) || 'N/A'}</td>
                                                                            <td>
                                                                                <span className={`badge ${cfg.configuration_type === 'pos' ? 'bg-primary' : 'bg-info'}`}>
                                                                                    {cfg.configuration_type?.toUpperCase() || 'N/A'}
                                                                                </span>
                                                                            </td>
                                                                            <td>
                                                                                <span className={`badge ${cfg.zatca_details?.zatca_environment_type === 'production' ? 'bg-success' : cfg.zatca_details?.zatca_environment_type === 'simulation' ? 'bg-warning text-dark' : 'bg-secondary'}`}>
                                                                                    {cfg.zatca_details?.zatca_environment_type?.toUpperCase() || 'N/A'}
                                                                                </span>
                                                                            </td>
                                                                            <td className="text-center">
                                                                                <i
                                                                                    className="ti ti-eye fs-5 me-3 cursor-pointer text-primary"
                                                                                    role="button"
                                                                                    title="View"
                                                                                    onClick={() => { setViewZatcaRecord(cfg); setViewZatcaModal(true); }}
                                                                                ></i>
                                                                                <i
                                                                                    className="ti ti-download fs-5 cursor-pointer text-success"
                                                                                    role="button"
                                                                                    title="Download"
                                                                                    onClick={() => generateZatcaPdf(cfg)}
                                                                                ></i>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        ) : (
                                                            <p className="text-center my-4">No ZATCA configurations found for this outlet</p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    <div className=" mt-2">
                                        <button className="btn ripple btn-secondary" type='button' onClick={() => navigate(-1)}>
                                            Back
                                        </button>
                                    </div>
                                </div>
                            </div> : <Loader />}
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                size="lg"
                show={viewZatcaModal}
                onHide={() => { setViewZatcaModal(false); setViewZatcaRecord(null); }}
                backdrop={true}
                className="modal-height-auto"
            >
                <Modal.Header className="text-white">
                    <Modal.Title>ZATCA Configuration Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {viewZatcaRecord && (
                        <div className="container overflow-auto" style={{ maxHeight: "70vh" }}>
                            <div className="row">
                                <div className="col-lg-6 mb-3">
                                    <label className="fw-semibold d-block">Configuration Name</label>
                                    <span>{capitalizeFirstLetter(viewZatcaRecord.configuration_name) || 'N/A'}</span>
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label className="fw-semibold d-block">Type</label>
                                    <span className={`badge ${viewZatcaRecord.configuration_type === 'pos' ? 'bg-primary' : 'bg-info'}`}>
                                        {viewZatcaRecord.configuration_type?.toUpperCase() || 'N/A'}
                                    </span>
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label className="fw-semibold d-block">Environment</label>
                                    <span className={`badge ${viewZatcaRecord.zatca_details?.zatca_environment_type === 'production' ? 'bg-success' : viewZatcaRecord.zatca_details?.zatca_environment_type === 'simulation' ? 'bg-warning text-dark' : 'bg-secondary'}`}>
                                        {viewZatcaRecord.zatca_details?.zatca_environment_type?.toUpperCase() || 'N/A'}
                                    </span>
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label className="fw-semibold d-block">Last Invoice Counter Number</label>
                                    <span>{viewZatcaRecord.zatca_details?.last_invoice_counter_number ?? viewZatcaRecord.last_invoice_counter_number ?? 'N/A'}</span>
                                </div>
                                {viewZatcaRecord.zatca_details && (
                                    <>
                                        <div className="col-lg-6 mb-3">
                                            <label className="fw-semibold d-block">Organization Name</label>
                                            <span>{capitalizeFirstLetter(viewZatcaRecord.zatca_details.vat_name) || 'N/A'}</span>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label className="fw-semibold d-block">VAT Number</label>
                                            <span>{viewZatcaRecord.zatca_details.vat_number || 'N/A'}</span>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label className="fw-semibold d-block">Organization Unit Name</label>
                                            <span>{capitalizeFirstLetter(viewZatcaRecord.zatca_details.organisation_unit_name) || 'N/A'}</span>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label className="fw-semibold d-block">Street</label>
                                            <span>{capitalizeFirstLetter(viewZatcaRecord.zatca_details.street) || 'N/A'}</span>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label className="fw-semibold d-block">Building</label>
                                            <span>{viewZatcaRecord.zatca_details.building || 'N/A'}</span>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label className="fw-semibold d-block">Plot Identification</label>
                                            <span>{viewZatcaRecord.zatca_details.plot_identification || 'N/A'}</span>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label className="fw-semibold d-block">City Subdivision</label>
                                            <span>{capitalizeFirstLetter(viewZatcaRecord.zatca_details.city_subdivision) || 'N/A'}</span>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label className="fw-semibold d-block">Postal Zone</label>
                                            <span>{viewZatcaRecord.zatca_details.postal_zone || 'N/A'}</span>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label className="fw-semibold d-block">Compliance Request ID</label>
                                            <span className="text-break small">{viewZatcaRecord.zatca_details.compliance_request_id || 'N/A'}</span>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label className="fw-semibold d-block">Compliance Secret</label>
                                            <span className="text-break small">{viewZatcaRecord.zatca_details.compliance_secret || 'N/A'}</span>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label className="fw-semibold d-block">Production Request ID</label>
                                            <span className="text-break small">{viewZatcaRecord.zatca_details.production_request_id || 'N/A'}</span>
                                        </div>
                                        <div className="col-lg-6 mb-3">
                                            <label className="fw-semibold d-block">Production Secret</label>
                                            <span className="text-break small">{viewZatcaRecord.zatca_details.production_secret || 'N/A'}</span>
                                        </div>
                                        <div className="col-12 mb-3">
                                            <label className="fw-semibold d-block">Private Key</label>
                                            <textarea className="form-control form-control-sm" rows={4} readOnly value={viewZatcaRecord.zatca_details.private_key || 'N/A'} />
                                        </div>
                                        <div className="col-12 mb-3">
                                            <label className="fw-semibold d-block">Public Key</label>
                                            <textarea className="form-control form-control-sm" rows={4} readOnly value={viewZatcaRecord.zatca_details.public_key || 'N/A'} />
                                        </div>
                                        <div className="col-12 mb-3">
                                            <label className="fw-semibold d-block">CSR</label>
                                            <textarea className="form-control form-control-sm" rows={4} readOnly value={viewZatcaRecord.zatca_details.csr || 'N/A'} />
                                        </div>
                                        <div className="col-12 mb-3">
                                            <label className="fw-semibold d-block">Compliance Certificate</label>
                                            <textarea className="form-control form-control-sm" rows={4} readOnly value={viewZatcaRecord.zatca_details.compliance_certificate || 'N/A'} />
                                        </div>
                                        <div className="col-12 mb-3">
                                            <label className="fw-semibold d-block">Production Certificate</label>
                                            <textarea className="form-control form-control-sm" rows={4} readOnly value={viewZatcaRecord.zatca_details.production_certificate || 'N/A'} />
                                        </div>
                                        <div className="col-12 mb-3">
                                            <label className="fw-semibold d-block">Last Invoice Hash</label>
                                            <textarea className="form-control form-control-sm" rows={2} readOnly value={viewZatcaRecord.zatca_details.last_invoice_hash || viewZatcaRecord.zatca_details.previous_invoice_hash || viewZatcaRecord.previous_invoice_hash || 'N/A'} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => generateZatcaPdf(viewZatcaRecord)}>
                        <i className="ti ti-download" aria-hidden="true"></i> Download
                    </Button>
                    <Button variant="secondary" onClick={() => { setViewZatcaModal(false); setViewZatcaRecord(null); }}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    )
}

export default OutletView